module.exports = __webpack_public_path__ + "static/media/Asset-4_2.fbe3bf17.png";